export const SCHOOL_YEAR = '2026-2027';

export const LEVEL_GROUPS = {
  preschool: {
    id: 'preschool',
    label: 'Maternelle / Préparatoire',
    levels: ['maternelle', 'préparatoire', 'preparatoire', 'prep'],
    registration: 250,
    tuition: { monthly: 250, quarterly: 670, annual: 2000 }
  },
  first_degree: {
    id: 'first_degree',
    label: '1er degré — 1ère et 2ème année',
    levels: ['1ère', '1ere', '1ère année', '1ere année', '2ème', '2eme', '2ème année', '2eme année'],
    registration: 250,
    tuition: { monthly: 270, quarterly: 720, annual: 2160 }
  },
  second_degree: {
    id: 'second_degree',
    label: '2ème degré — 3ème et 4ème année',
    levels: ['3ème', '3eme', '3ème année', '3eme année', '4ème', '4eme', '4ème année', '4eme année'],
    registration: 270,
    tuition: { monthly: 290, quarterly: 790, annual: 2340 }
  },
  third_degree: {
    id: 'third_degree',
    label: '3ème degré — 5ème et 6ème année',
    levels: ['5ème', '5eme', '5ème année', '5eme année', '6ème', '6eme', '6ème année', '6eme année'],
    registration: 290,
    tuition: { monthly: 300, quarterly: 840, annual: 2520 }
  }
};

export const SERVICE_CATALOG = {
  basket: {
    id: 'basket', label: 'Panier', frequencies: { annual: 750, quarterly: 250, monthly: 100, daily: 8 }
  },
  daycare: {
    id: 'daycare', label: 'Garderie', frequencies: { daily: 12 }
  },
  cafeteria: {
    id: 'cafeteria', label: 'Cantine', note: '4 repas par semaine', frequencies: { annual: 2160, quarterly: 720, monthly: 250, daily: 15 }
  },
  transport_bizerte: {
    id: 'transport_bizerte', label: 'Transport Bizerte', frequencies: { annual: 1800, quarterly: 600, monthly: 200, daily: 10 }
  },
  transport_sekma: {
    id: 'transport_sekma', label: 'Transport Sekma', frequencies: { annual: 1980, quarterly: 660, monthly: 220, daily: 12 }
  },
  transport_zarzouna: {
    id: 'transport_zarzouna', label: 'Transport Zarzouna', frequencies: { annual: 2250, quarterly: 750, monthly: 250, daily: 15 }
  }
};

export const FREQUENCY_LABELS = {
  monthly: 'Mensuel',
  quarterly: 'Trimestriel',
  annual: 'Annuel',
  daily: 'Journalier',
  once: 'Paiement unique'
};

export function normalizeText(value) {
  return String(value || '').trim().toLowerCase();
}

export function detectLevelGroup(level) {
  const normalized = normalizeText(level);
  return Object.values(LEVEL_GROUPS).find((group) =>
    group.levels.some((candidate) => normalized.includes(normalizeText(candidate)))
  )?.id || 'preschool';
}

export function installmentsCount(frequency) {
  if (frequency === 'monthly') return 10;
  if (frequency === 'quarterly') return 3;
  return 1;
}

export function tariffTotal(unitAmount, frequency, quantity = 1) {
  if (frequency === 'monthly') return Number(unitAmount || 0) * 10;
  if (frequency === 'quarterly') return Number(unitAmount || 0) * 3;
  if (frequency === 'daily') return Number(unitAmount || 0) * Number(quantity || 0);
  return Number(unitAmount || 0);
}
